import {create} from "zustand";

const useShowModal =  create((set, get) => ({
    showLoginAlert: false,
    setShowLoginAlert: (show) => set({ showLoginAlert: show }),
    actions :{

    }

}))
export default useShowModal;